import CurrentLocationComponent from '../../components/CurrentLocation';
import CustomSearchIcon from '../../components/icons/SearchIcon';
import LocationAutocompleteComponent from '../../components/autocomplete/LocationAutocomplete';
import { BodyGrey, BodyLarge } from '../../components/Typography';
import { Box, styled } from '@mui/material';
import { palette } from '../../theme/palette';

export const Menu = styled(Box)`
  width: calc(100vw - 20px);
  max-width: 335px;
  border-radius: 5px;
  box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.1);
  height: fit-content;
  position: absolute;
  top: 50px;
  z-index: 901;
  background: ${palette.custom.white};
`;

export const MenuContentWrapper = styled(Box)`
  padding: 20px;
`;

export const ArrowContainer = styled(Box)`
  position: absolute;
  top: -20px;
  left: 35px;
`;

export const Arrow = styled(Box)`
  width: 40px;
  height: 21px;
  position: relative;
  overflow: hidden;
  :after {
    content: '';
    position: absolute;
    width: 30px;
    height: 30px;
    background: ${palette.custom.white};
    transform: rotate(45deg);
    top: 8px;
    left: 5px;
    border-radius: 5px 0 0 0;
    box-shadow: -1px -1px 10px -2px rgba(0, 0, 0, 0.15);
  }
`;

export const LocationAutocomplete = styled(LocationAutocompleteComponent)`
  border-radius: 5px;
  border: 1px solid ${palette.custom.grey};
  .autocomplete-dropdown {
    padding: 0 10px 0 10px;
  }
  .autocomplete-dropdown-item {
    padding: 0;
    transition: padding 0.4s ease-in-out;
  }
  .autocomplete-dropdown-item:hover {
    padding: 0 10px 0 10px;
    transition: padding 0.4s ease-in-out;
  }
`;

export const CurrentLocation = styled(CurrentLocationComponent)`
  width: 100%;
  border-radius: 5px;
  border: 1px solid;
  background: ${palette.custom.white};
  height: 40px;
  margin-top: 14px;
`;

export const LocationLabel = styled(BodyLarge)`
  margin-bottom: 6px;
`;

export const HelperText = styled(BodyGrey, {
  shouldForwardProp: (prop) => prop !== 'hasError',
})<{
  hasError?: boolean;
}>`
  color: ${(props) => (props.hasError ? palette.error.main : palette.custom.mediumGrey)};
  margin-top: 4px;
  margin-bottom: 8px;
  margin-left: 2px;
`;

export const SearchIcon = styled(CustomSearchIcon)`
  color: ${palette.custom.mediumGrey};
  width: 16px;
`;
